import React from 'react';
import { Segment, Container } from 'semantic-ui-react';
import TopMenu from './TopMenu';
import '../styles/HeaderBlock.css';

const HeaderSmall = () => (
  <div>
    <TopMenu />
    <Container style={{ minHeight: '2em' }} />
    <Segment
      className="landing-image-small"
      inverted
      // color="orange"
      textAlign="center"
      style={{
        minHeight: '10em',
        padding: '1em 0em',
      }}
      vertical
    />
  </div>
);

export default HeaderSmall;



// WEBPACK FOOTER //
// ./src/components/HeaderSmall.js